"use client";
import { useLoadingVisibility as e } from "../../motion/useLoadingVisibility.js";
import { getControlClassNames as t } from "../controls/control-class-names.js";
import { ControlHint as n } from "../controls/ControlHint.js";
import { ControlIcon as r } from "../controls/ControlIcon.js";
import { CheckIcon as i } from "../icons/CheckIcon.js";
import { ButtonSpinner as a } from "./ButtonSpinner.js";
import { useButtonWidth as o } from "./useButtonWidth.js";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
import u from "clsx";
import { Button as d } from "@base-ui/react/button";
import { forwardRef as f, useCallback as p, useId as m } from "react";
//#region src/components/button/Button.tsx
var h = f(({ variant: f = "primary", size: h = "md", destructive: g = !1, loadingConfig: _, completionConfig: v, leadingIcon: y, trailingIcon: b, disabled: x = !1, disabledReason: S, className: C, children: w, type: T = "button", focusableWhenDisabled: E, "aria-describedby": D, ...O }, k) => {
	let A = m(), j = _?.isLoading === !0, M = e(j), N = !M && !j && v?.isComplete === !0, P = x ? S : void 0, F = h === "lg" ? 20 : 16, { buttonRef: I, contentRef: L } = o(M ? "loading" : N ? "complete" : "idle", !!(_ || v)), R = p((e) => {
		I.current = e, typeof k == "function" ? k(e) : k && (k.current = e);
	}, [I, k]);
	return /* @__PURE__ */ l(s, { children: [
		/* @__PURE__ */ c(n, {
			label: P,
			children: /* @__PURE__ */ c(d, {
				...O,
				ref: R,
				type: T,
				disabled: x || j,
				focusableWhenDisabled: E ?? (j || !!P),
				"aria-busy": j || void 0,
				"aria-describedby": [D, P ? A : void 0].filter(Boolean).join(" ") || void 0,
				"data-variant": f,
				"data-size": h,
				"data-destructive": g || void 0,
				"data-loading": j || void 0,
				"data-unavailable": x || void 0,
				className: u("pf-control pf-button", j && "pf:opacity-50", t({
					variant: f,
					size: h,
					destructive: g,
					disabled: x,
					loading: j
				}), f !== "link" && f !== "link-subtle" && "pf-motion-press", C),
				children: /* @__PURE__ */ l("span", {
					ref: L,
					className: "pf:inline-flex pf:items-center pf:justify-center pf:min-w-0 pf:max-w-full pf:gap-[inherit]",
					children: [
						M ? /* @__PURE__ */ c(a, { size: F }) : N ? /* @__PURE__ */ c(r, {
							size: F,
							children: v.icon ?? /* @__PURE__ */ c(i, {})
						}) : y ? /* @__PURE__ */ c(r, {
							size: F,
							children: y
						}) : null,
						/* @__PURE__ */ c("span", {
							className: u("pf-button-label pf:min-w-0", _ || v || M ? "pf:truncate" : "pf:wrap-anywhere", f !== "link" && f !== "link-subtle" && "pf:px-xxs"),
							children: M ? _?.label ?? w : N ? v.label : w
						}),
						b && /* @__PURE__ */ c(r, {
							size: F,
							children: b
						})
					]
				})
			})
		}),
		P && /* @__PURE__ */ c("span", {
			id: A,
			className: "pf-control-sr pf:sr-only",
			children: P
		}),
		/* @__PURE__ */ c("span", {
			className: "pf-control-sr pf:sr-only",
			role: "status",
			children: j ? _.label ?? "Loading" : N ? v.label : ""
		})
	] });
});
h.displayName = "PathfinderButton";
//#endregion
export { h as Button };
